export default __webpack_public_path__ + "static/media/sd-delete-black-icon.ae31c529.png";